"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDrillDownDefinition = exports.isDashboardFilter = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2023 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var sdk_model_1 = require("@gooddata/sdk-model");
/**
 * Type-guard testing whether the provided object is an instance of {@link IDashboardFilter}.
 *
 * @alpha
 */
function isDashboardFilter(obj) {
    return sdk_model_1.isAttributeFilter(obj) || sdk_model_1.isDateFilter(obj);
}
exports.isDashboardFilter = isDashboardFilter;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillDownDefinition}.
 * @beta
 */
function isDrillDownDefinition(obj) {
    return !isEmpty_1.default(obj) && obj.type === "drillDown";
}
exports.isDrillDownDefinition = isDrillDownDefinition;
//# sourceMappingURL=types.js.map